import { createContext } from 'react'

/** Overlay root above the scrollable drawer body, inside the active drawer. */
export const TripDrawerMapPreviewContext = createContext<HTMLElement | null>(null)
